import { memo, useContext, useState } from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CloseIcon, ConnectIcon } from '~/assets/icons';
import ModalAlertConfirm from '~/components/common/modal-alert-confirm/ModalAlertConfirm';
import { ConnectionStatusEnum } from '~/utils/enum';
import { RingCentralContext } from '~/context/RingCentralContext';

const RingCentralConnectButton = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { ringCentralStatus, connect, disconnect } = useContext(RingCentralContext);
  const { t } = useTranslation(['admin/ring-central']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [openDisconnectConfirm, setOpenDisconnectConfirm] = useState<boolean>(false);
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleDisconnectConfirm = () => {
    setOpenDisconnectConfirm(false);
    disconnectRingCentral();
  };

  const connectRingCentral = () => {
    connect && connect();
  };

  const disconnectRingCentral = () => {
    disconnect && disconnect();
  };
  //#endregion Handle Function

  return (
    <>
      <Box>
        {ringCentralStatus === ConnectionStatusEnum.CONNECTED ? (
          <Button
            variant='contained'
            color='error'
            onClick={() => setOpenDisconnectConfirm(true)}
            startIcon={<CloseIcon className='w-[12px] h-[12px] [&>path]:fill-[#FFFFFF]' />}
          >
            {t('disconnectRingCentral')}
          </Button>
        ) : (
          <Button
            variant='contained'
            disabled={ringCentralStatus === ConnectionStatusEnum.CONNECTING}
            onClick={connectRingCentral}
            startIcon={<ConnectIcon className='w-[12px] h-[12px]' />}
          >
            {t('connectRingCentral')}
          </Button>
        )}
      </Box>

      <ModalAlertConfirm
        open={openDisconnectConfirm}
        description={t('disconnectConfirmDesciption')}
        confirm={t('disconnectConfirmYes')}
        onCancel={() => {
          setOpenDisconnectConfirm(false);
        }}
        onConfirm={handleDisconnectConfirm}
      />
    </>
  );
};

export default memo(RingCentralConnectButton);
